var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpgradeCta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 119,
    viewBox: "0 0 149 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8743 119C68.0623 119 73.0786 117.726 73.0786 116.155C73.0786 114.584 68.0623 113.31 61.8743 113.31C55.6864 113.31 50.67 114.584 50.67 116.155C50.67 117.726 55.6864 119 61.8743 119Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7105 87.5366C68.8984 87.5366 73.9147 86.2628 73.9147 84.6915C73.9147 83.1202 68.8984 81.8464 62.7105 81.8464C56.5225 81.8464 51.5062 83.1202 51.5062 84.6915C51.5062 86.2628 56.5225 87.5366 62.7105 87.5366Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2043 88.8755C17.3922 88.8755 22.4085 87.6017 22.4085 86.0304C22.4085 84.4591 17.3922 83.1853 11.2043 83.1853C5.01632 83.1853 0 84.4591 0 86.0304C0 87.6017 5.01632 88.8755 11.2043 88.8755Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.831 0.669434H3.78271V3.09613H67.831V0.669434Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8343 0H2.61206V81.3361H68.8343V0Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.831 3.09619H3.78271V79.9972H67.831V3.09619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10043 2.51037C5.42368 2.51037 5.68573 2.24812 5.68573 1.92462C5.68573 1.60112 5.42368 1.33887 5.10043 1.33887C4.77718 1.33887 4.51514 1.60112 4.51514 1.92462C4.51514 2.24812 4.77718 2.51037 5.10043 2.51037Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7092 2.51037C7.03245 2.51037 7.29449 2.24812 7.29449 1.92462C7.29449 1.60112 7.03245 1.33887 6.7092 1.33887C6.38595 1.33887 6.1239 1.60112 6.1239 1.92462C6.1239 2.24812 6.38595 2.51037 6.7092 2.51037Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31955 2.51037C8.6428 2.51037 8.90485 2.24812 8.90485 1.92462C8.90485 1.60112 8.6428 1.33887 8.31955 1.33887C7.9963 1.33887 7.73425 1.60112 7.73425 1.92462C7.73425 2.24812 7.9963 2.51037 8.31955 2.51037Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5391 6.0249H5.62219V7.53113H30.5391V6.0249Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.2653 12.2172H23.3484V13.7234H48.2653V12.2172Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.5391 60.751H5.62219V62.2572H30.5391V60.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2451 60.5836H33.8837V62.4245H42.2451V60.5836Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2451 69.9557H33.8837V71.7966H42.2451V69.9557Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3023 69.9557H50.9409V71.7966H59.3023V69.9557Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0778 60.751H34.2181V62.2572H42.0778V60.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0778 70.123H34.2181V71.6293H42.0778V70.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9679 70.123H51.1082V71.6293H58.9679V70.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5391 65.437H5.62219V66.9432H30.5391V65.437Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.1351 65.437H34.2181V66.9432H59.1351V65.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1351 74.8091H34.2181V76.3153H59.1351V74.8091Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.5391 70.123H5.62219V71.6293H30.5391V70.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5391 74.8091H5.62219V76.3153H30.5391V74.8091Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3955 14.7275H23.3484V16.2338H37.3955V14.7275Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7535 14.7275H39.9039V16.2338H44.7535V14.7275Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3955 19.7483H23.3484V21.2545H37.3955V19.7483Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7535 19.7483H39.9039V21.2545H44.7535V19.7483Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2653 17.2379H23.3484V18.7441H48.2653V17.2379Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.6569 6.0249H40.74V7.53113H65.6569V6.0249Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.7972 12.0498H54.7871V13.8907H57.7972V12.0498Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7972 14.5602H54.7871V16.4011H57.7972V14.5602Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7972 17.0706H54.7871V18.9115H57.7972V17.0706Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6301 12.2172H54.9545V13.7234H57.6301V12.2172Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6301 14.7275H54.9545V16.2338H57.6301V14.7275Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6301 17.2379H54.9545V18.7441H57.6301V17.2379Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7972 19.5809H54.7871V21.4219H57.7972V19.5809Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6301 19.7483H54.9545V21.2545H57.6301V19.7483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4931 30.4592H5.12048V55.5629H66.4931V30.4592Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.657 30.9613H5.62219V54.7262H65.657V30.9613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.4617 32.8022H65.657V30.9613H5.62219V54.7262H7.4617V32.8022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0508 28.8821L5.43115 34.4943L7.73491 59.828L69.3546 54.2158L67.0508 28.8821Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2781 29.6226L6.49036 35.068L8.64255 58.735L68.4303 53.2897L66.2781 29.6226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.9534 54.4901L9.91663 41.3073C9.91663 41.3073 15.2679 35.6172 26.0708 39.8346C36.8737 44.052 41.9675 41.0747 43.7234 38.2263C45.4793 35.3778 54.5932 32.2014 57.5465 36.9661C60.4997 41.7308 64.0416 36.3736 64.0416 36.3736L65.2389 49.5397L10.9534 54.4901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3933 38.4354L16.4836 39.4362",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6593 41.3541L17.6192 51.9077",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeDasharray: "11.51 11.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7061 52.8667L17.798 53.8658",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6761 40.069L26.7681 41.0681",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9655 43.2454L27.6594 50.8618",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeDasharray: "13.06 13.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7582 51.9496L27.8485 52.9504",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1681 41.8563L37.2684 42.8554",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4305 44.4872L37.9958 50.1941",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeDasharray: "9.79 9.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0778 51.009L38.1764 52.0098",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.598 35.9552L46.6883 36.956",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8589 38.8354L47.8004 49.1765",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeDasharray: "11.28 11.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8857 50.1154L47.9777 51.1162",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4043 34.5745L53.4946 35.5736",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.675 37.5619L54.67 48.4954",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeDasharray: "11.93 11.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7604 49.4895L54.8524 50.4886",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4376 39.2045C16.8975 39.1626 17.2364 38.7556 17.1945 38.2953C17.1527 37.8351 16.746 37.4959 16.2861 37.5378C15.8262 37.5797 15.4873 37.9867 15.5292 38.447C15.571 38.9072 15.9777 39.2464 16.4376 39.2045Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.672 40.9618C27.1319 40.9199 27.4708 40.5129 27.4289 40.0526C27.3871 39.5924 26.9803 39.2532 26.5204 39.2951C26.0606 39.337 25.7217 39.7441 25.7635 40.2043C25.8054 40.6646 26.2121 41.0037 26.672 40.9618Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2415 42.6872C37.7013 42.6453 38.0402 42.2382 37.9984 41.778C37.9565 41.3177 37.5498 40.9786 37.0899 41.0205C36.63 41.0624 36.2911 41.4694 36.333 41.9297C36.3748 42.3899 36.7816 42.7291 37.2415 42.6872Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6426 37.1255C47.2865 37.0669 47.7609 36.497 47.7023 35.8526C47.6437 35.2083 47.0743 34.7335 46.4304 34.7921C45.7866 34.8508 45.3121 35.4207 45.3707 36.065C45.4293 36.7093 45.9988 37.1841 46.6426 37.1255Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5765 35.8225C54.2203 35.7639 54.6947 35.194 54.6361 34.5497C54.5775 33.9053 54.0081 33.4305 53.3643 33.4892C52.7204 33.5478 52.246 34.1177 52.3046 34.762C52.3632 35.4064 52.9326 35.8812 53.5765 35.8225Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6123 36.7922C47.0722 36.7503 47.4111 36.3432 47.3692 35.883C47.3274 35.4227 46.9206 35.0836 46.4607 35.1255C46.0009 35.1673 45.662 35.5744 45.7038 36.0346C45.7457 36.4949 46.1524 36.834 46.6123 36.7922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5462 35.4892C54.006 35.4473 54.3449 35.0402 54.3031 34.58C54.2612 34.1197 53.8545 33.7806 53.3946 33.8225C52.9347 33.8644 52.5958 34.2714 52.6377 34.7317C52.6795 35.1919 53.0863 35.5311 53.5462 35.4892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.144 37.5485C64.6039 37.5066 64.9428 37.0996 64.9009 36.6393C64.8591 36.1791 64.4524 35.8399 63.9925 35.8818C63.5326 35.9237 63.1937 36.3307 63.2356 36.791C63.2774 37.2512 63.6842 37.5904 64.144 37.5485Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.764 53.3405L65.7759 53.3796C65.9067 53.3066 65.764 53.3405 65.764 53.3405Z",
    fill: "url(#paint12_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.3793 81.4532L67.1018 81.013L66.7272 79.3395V79.316H66.7172L64.7874 70.446V63.9776C64.7871 63.8955 64.7827 63.8134 64.774 63.7316C67.657 59.9058 65.9446 53.9027 65.7774 53.3789C65.7472 53.3939 65.7021 53.414 65.6385 53.4391C65.6177 53.2049 65.5734 52.9733 65.5064 52.7479C65.5064 52.7479 64.6703 52.2157 64.2138 52.9002C63.8158 53.4977 64.1118 53.8625 64.1937 53.9479L64.1368 53.9663C64.265 54.1678 64.3546 54.3914 64.4011 54.6257C64.3747 54.568 64.3445 54.5121 64.3108 54.4583C64.2054 54.4399 64.1435 54.4232 64.1435 54.4232L64.1235 54.4048L64.0666 54.4232C64.3559 54.8466 64.4579 55.5947 64.4445 56.4817C64.3446 56.3432 64.2327 56.2139 64.1101 56.0951C63.5815 55.5897 62.8843 55.2987 62.1535 55.2784H62.0147C61.9389 55.2784 61.8631 55.2834 61.7873 55.2934H61.7304L61.6351 55.3068L61.5264 55.3269L61.4478 55.3436L61.3124 55.3805L61.2622 55.3955C61.2053 55.4139 61.1502 55.4323 61.095 55.4541C60.9116 55.5434 60.7194 55.6129 60.5214 55.6616C60.4946 55.6616 60.4679 55.6616 60.4394 55.67C60.2159 55.6856 59.994 55.6223 59.8123 55.4909L59.7521 55.444C59.7294 55.4245 59.7076 55.4039 59.6869 55.3821C59.6642 55.4401 59.6545 55.5024 59.6585 55.5645C59.671 55.7121 59.7414 55.8486 59.8541 55.9445C59.8858 55.9719 59.9206 55.9955 59.9578 56.0147C60.0128 56.0436 60.0732 56.0607 60.1351 56.065H60.1986H60.1836C60.1451 56.0834 60.1067 56.1001 60.0665 56.1152H60.0582C60.0147 56.1302 59.9729 56.1436 59.9277 56.1553C59.7086 56.2107 59.4795 56.2142 59.2588 56.1654L59.1869 56.1486C59.1518 56.1386 59.115 56.1285 59.0815 56.1168C59.0925 56.142 59.1048 56.1666 59.1183 56.1905L59.1317 56.2122L59.1618 56.2591L59.1802 56.2825L59.2137 56.3244L59.2337 56.3461L59.2755 56.388L59.2923 56.403L59.3541 56.4549L59.3759 56.47L59.421 56.5018L59.4511 56.5202L59.4913 56.5436L59.5247 56.5603L59.5665 56.5787L59.6016 56.5938L59.6485 56.6105L59.707 56.6273L59.7505 56.639H59.7923H59.8307H59.8742H60.0414C60.1277 56.6315 60.2124 56.6106 60.2923 56.5771L60.1384 56.6407L60.0615 56.6674L59.9829 56.6959L59.9043 56.7193L59.824 56.7428L59.7454 56.7628L59.6618 56.7829L59.5849 56.798L59.4963 56.813L59.4227 56.8248L59.3274 56.8365H59.2588H59.1501H59.0933H58.926C59.0185 56.8634 59.1044 56.9089 59.1785 56.9704C59.2265 57.005 59.2788 57.0331 59.3341 57.054C59.3588 57.0612 59.3839 57.0668 59.4093 57.0708H59.4311H59.4846H59.7103H59.7839C59.9364 57.0862 60.084 57.1335 60.217 57.2097C60.2875 57.2551 60.3502 57.3116 60.4027 57.377C60.3792 57.4155 60.3558 57.4524 60.3358 57.4925C60.3157 57.5327 60.3006 57.5595 60.2839 57.5946C60.2505 57.6638 60.2209 57.7346 60.1953 57.8072C60.1001 58.0672 60.0514 58.3419 60.0515 58.6188C60.0515 58.6707 60.0515 58.7209 60.0515 58.7711C60.0515 58.7845 60.0515 58.7996 60.0515 58.813C60.0515 58.8531 60.0559 58.8933 60.0648 58.9335V58.9653C60.0715 59.0144 60.0805 59.0629 60.0916 59.1109V59.1393C60.1005 59.1795 60.1106 59.2191 60.1217 59.2581L60.1317 59.2933C60.1599 59.388 60.1939 59.4807 60.2337 59.5711L60.2455 59.5979C60.2644 59.6392 60.2839 59.6793 60.304 59.7184V59.7301C60.3285 59.7747 60.3542 59.8188 60.3809 59.8623V59.8724C60.4054 59.9125 60.4316 59.9516 60.4595 59.9895L60.4695 60.0029C60.5296 60.0857 60.595 60.1645 60.6652 60.2389C60.8474 60.4309 61.0605 60.591 61.2956 60.7125C61.2876 60.7484 61.2815 60.7847 61.2772 60.8213C61.2752 60.8592 61.2752 60.8972 61.2772 60.9351V61.8187C61.2271 61.8455 61.178 61.874 61.1301 61.9041C59.0347 60.9518 55.9143 54.2056 55.9143 54.2056H55.839C56.1434 53.978 55.839 52.9872 55.839 52.9872C55.6604 52.8806 55.4606 52.8144 55.2537 52.7931H55.0865H55.0564H55.0346H55.0045H54.9845L54.951 52.8031H54.9343L54.8841 52.8216L54.8373 52.8433L54.8206 52.8517L54.7888 52.8701L54.7671 52.9722L54.737 52.9923L54.7186 53.0073L54.6902 53.0307L54.6718 53.0475L54.6433 53.0743L54.6266 53.0927L54.5982 53.1261L54.5848 53.1429L54.543 53.1998C54.0865 53.8843 54.543 54.2659 54.543 54.2659C54.5136 54.5298 54.4996 54.7952 54.5012 55.0608C54.4677 59.9912 59.7404 63.812 60.0097 64.0028C59.8909 64.3107 58.911 67.0386 60.0214 70.4444C60.0248 70.4527 60.0293 70.4606 60.0347 70.4678C58.7704 71.6338 57.832 73.1099 57.3123 74.75C56.7926 76.3902 56.7096 78.1377 57.0715 79.8198L57.0932 79.9219H57.1417C57.1367 79.9445 57.1306 79.9668 57.1233 79.9888C57.1104 80.0291 57.0942 80.0683 57.0748 80.106C57.0414 80.1703 57.0004 80.2304 56.9527 80.285C56.9009 80.3453 56.8407 80.4055 56.7772 80.4674L56.7103 80.531C56.4444 80.7854 56.1751 81.0331 56.3758 81.1335H59.2538V79.8767H59.304C59.304 79.8767 59.2839 79.8382 59.2538 79.7629V79.7495H59.2438C59.0933 79.3612 58.7421 78.1596 59.304 76.3086C59.9879 74.0242 62.6485 72.8828 62.6485 72.8828L62.697 73.0501H62.687L64.774 79.9118C64.774 79.9386 64.774 79.9654 64.7656 79.9938C64.7562 80.0586 64.7411 80.1225 64.7205 80.1846C64.7045 80.2326 64.6855 80.2796 64.6636 80.3252C64.5348 80.5913 64.3124 80.9042 64.2154 81.1386C64.2016 81.1706 64.1898 81.2036 64.1803 81.2373C64.1688 81.2752 64.1649 81.315 64.1686 81.3545C64.1715 81.3795 64.1813 81.4033 64.197 81.4232C64.2126 81.443 64.2335 81.458 64.2572 81.4666H64.2957L64.376 81.4532H64.3793ZM63.5733 61.9175C63.5209 61.8885 63.4651 61.8611 63.4061 61.8355V61.0054C63.4056 60.9419 63.3994 60.8786 63.3877 60.8162C63.5679 60.7303 63.7364 60.6217 63.8893 60.4932C63.789 61.0054 63.677 61.4957 63.575 61.9175H63.5733Z",
    fill: "url(#paint13_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.4962 54.9956C54.4962 54.9956 53.9945 54.5739 54.4962 53.8141C54.9978 53.0543 55.9293 53.6467 55.9293 53.6467C55.9293 53.6467 56.2638 54.7429 55.9293 54.9956C55.5948 55.2483 54.4962 54.9956 54.4962 54.9956Z",
    fill: "#CA7070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7071 83.2222H57.3843C57.3929 83.3317 57.3777 83.4417 57.3399 83.5449C57.3021 83.648 57.2425 83.7417 57.1652 83.8196C56.8525 84.1811 56.2237 84.6179 56.5197 84.7669H59.7071V83.2222Z",
    fill: "#00695C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.334 83.8196C57.4113 83.7417 57.4709 83.648 57.5088 83.5449C57.5466 83.4417 57.5617 83.3317 57.5531 83.2222H57.3859C57.3945 83.3317 57.3793 83.4417 57.3415 83.5449C57.3037 83.648 57.2441 83.7417 57.1668 83.8196C56.8541 84.1811 56.2253 84.6179 56.5213 84.7669H56.6885C56.3925 84.6179 57.0213 84.1828 57.334 83.8196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9781 82.7435L65.8041 83.0967C65.8642 83.3557 65.8292 83.6278 65.7054 83.8632C65.468 84.3652 64.9345 84.9911 65.2556 85.1267L68.4028 84.6246L67.9781 82.7435Z",
    fill: "#00695C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9179 53.9663C66.9179 53.9663 69.4046 61.8171 65.2339 66.1634L64.0299 65.2412C64.0299 65.2412 66.4948 56.6725 65.1152 54.6609C67.5501 53.8492 66.9179 53.9663 66.9179 53.9663Z",
    fill: "#00695C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1988 54.6592C65.1988 54.6592 64.6971 54.2374 65.1988 53.4776C65.7005 52.7178 66.6319 53.3103 66.6319 53.3103C66.6319 53.3103 66.9664 54.4065 66.6319 54.6592C66.2975 54.9119 65.1988 54.6592 65.1988 54.6592Z",
    fill: "#CA7070"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.8727 83.8649C65.9968 83.6291 66.0319 83.3563 65.9713 83.0967L67.9781 82.762V82.7352L65.8041 83.0967C65.8642 83.3558 65.8292 83.6279 65.7054 83.8632C65.468 84.3653 64.9345 84.9912 65.2556 85.1268L65.3877 85.105C65.1486 84.9376 65.6452 84.3368 65.8727 83.8649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3142 62.4615C64.3142 61.8089 63.786 61.2799 63.1344 61.2799C62.4828 61.2799 61.9546 61.8089 61.9546 62.4615V63.5978C61.9546 64.2504 62.4828 64.7794 63.1344 64.7794C63.786 64.7794 64.3142 64.2504 64.3142 63.5978V62.4615Z",
    fill: "#CA7070"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.1988 65.7467C64.1988 65.7467 66.6337 57.2834 65.3075 55.2031C65.1905 55.1813 65.1152 55.1646 65.1152 55.1646L65.0935 55.1445L65.0316 55.1646C66.4112 57.1729 63.9463 65.745 63.9463 65.745L65.1503 66.6671L65.2557 66.5533L64.1988 65.7467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.177 62.5033C64.6197 62.5033 65.7891 61.3329 65.7891 59.8892C65.7891 58.4454 64.6197 57.275 63.177 57.275C61.7344 57.275 60.5649 58.4454 60.5649 59.8892C60.5649 61.3329 61.7344 62.5033 63.177 62.5033Z",
    fill: "#CA7070"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.2489 63.5994V62.4614C62.249 62.3781 62.2579 62.2951 62.2756 62.2137C61.7655 61.9515 61.3558 61.5286 61.1097 61.0103C60.8636 60.4919 60.7947 59.9069 60.9138 59.3455C61.0329 58.7841 61.3333 58.2776 61.7686 57.904C62.2039 57.5304 62.7499 57.3105 63.3225 57.2783H63.1753C62.5894 57.2781 62.0204 57.4751 61.5598 57.8376C61.0992 58.2001 60.7738 58.707 60.6358 59.2769C60.4979 59.8468 60.5554 60.4466 60.7991 60.9798C61.0428 61.5131 61.4586 61.9488 61.9796 62.2171C61.9619 62.2984 61.953 62.3815 61.9529 62.4647V63.6028C61.9513 63.7708 61.986 63.9372 62.0544 64.0907C62.1228 64.2441 62.2233 64.381 62.3493 64.4922C62.4752 64.6033 62.6236 64.686 62.7843 64.7347C62.945 64.7834 63.1143 64.7969 63.2807 64.7743C62.9954 64.7373 62.7334 64.5977 62.5435 64.3815C62.3537 64.1653 62.2489 63.8873 62.2489 63.5994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8309 72.9179C65.8309 72.9179 60.7923 73.487 60.6067 72.9179C59.3007 68.9114 60.6067 65.75 60.6067 65.75C60.6067 65.0567 60.8819 64.3918 61.3718 63.9015C61.8616 63.4113 62.526 63.1359 63.2188 63.1359C63.9116 63.1359 64.576 63.4113 65.0658 63.9015C65.5557 64.3918 65.8309 65.0567 65.8309 65.75V72.9179Z",
    fill: "#00695C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8309 72.918L68.1068 83.3762H65.8309L63.4713 75.6175C63.4713 75.6175 60.5214 76.8827 59.7638 79.4131C59.0063 81.9436 59.7638 83.3762 59.7638 83.3762H57.319L57.2939 83.2624C56.8917 81.399 56.9859 79.4625 57.567 77.647C58.1481 75.8315 59.1958 74.2007 60.605 72.918",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.901 72.9179C59.5949 68.9114 60.901 65.75 60.901 65.75C60.9009 65.0859 61.1533 64.4466 61.6071 63.962C62.0609 63.4774 62.6819 63.1838 63.3442 63.1409C63.289 63.1409 63.2321 63.1409 63.1769 63.1409C62.4842 63.1409 61.8198 63.4163 61.3299 63.9065C60.84 64.3968 60.5648 65.0617 60.5648 65.755C60.5648 65.755 59.2588 68.9181 60.5648 72.923C60.6317 73.1271 61.3207 73.184 62.1769 73.1757C61.4813 73.1606 60.9545 73.0937 60.901 72.9179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5649 65.7064C60.5649 65.7064 53.824 60.9836 54.4979 54.9955H56.0147C56.0147 54.9955 59.6368 62.8463 61.958 63.5994C64.2791 64.3525 60.5649 65.7064 60.5649 65.7064Z",
    fill: "#00695C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.5148 75.8016L65.8309 83.418H66.1653L63.8057 75.6593C63.8057 75.6593 63.697 75.7062 63.5148 75.8016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.9429 72.9598H60.6084C59.1992 74.2425 58.1515 75.8733 57.5704 77.6889C56.9893 79.5044 56.8951 81.4408 57.2973 83.3042L57.3224 83.4181H57.6568L57.6317 83.3042C57.2296 81.4408 57.3237 79.5044 57.9049 77.6889C58.486 75.8733 59.5336 74.2425 60.9429 72.9598Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.7504 55.0809H54.4979C53.829 61.069 60.5649 65.7919 60.5649 65.7919L60.7321 65.7283C59.9512 65.1509 54.1199 60.6707 54.7504 55.0809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0934 58.7209C61.239 59.0575 61.3413 59.4112 61.3977 59.7736C61.565 60.5066 61.9429 61.238 62.5934 61.6145C62.9537 61.8101 63.3544 61.9195 63.764 61.9342C64.3861 61.9727 65.06 61.8522 65.4998 61.4104C65.7738 61.111 65.9575 60.7403 66.0299 60.3409C66.1615 59.751 66.1434 59.1374 65.9772 58.5562C65.811 57.9751 65.502 57.4448 65.0784 57.0138C64.6435 56.5935 64.0989 56.3047 63.5072 56.1807C62.9154 56.0566 62.3007 56.1023 61.7338 56.3126C61.5313 56.4118 61.3189 56.4892 61.1001 56.5436C60.9325 56.5704 60.761 56.5565 60.6 56.5029C60.439 56.4492 60.2933 56.3576 60.1753 56.2356C60.1482 56.3235 60.1422 56.4165 60.1577 56.5072C60.1733 56.5978 60.2101 56.6834 60.265 56.7572C60.3199 56.8309 60.3915 56.8906 60.4738 56.9314C60.5562 56.9722 60.647 56.993 60.7388 56.9921C60.5456 57.085 60.3358 57.1387 60.1218 57.1502C59.9077 57.1617 59.6934 57.1307 59.4913 57.059C59.6059 57.3005 59.8074 57.4898 60.0555 57.5888C60.3036 57.6878 60.58 57.6893 60.8291 57.5929C60.3558 57.8038 59.8422 57.9089 59.3241 57.9008C59.4328 57.9008 59.6452 58.1017 59.7773 58.1418C59.9432 58.1682 60.111 58.18 60.279 58.177C60.4506 58.1876 60.6164 58.2435 60.7595 58.339C60.9025 58.4345 61.0177 58.5663 61.0934 58.7209Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.7456 56.9889C60.552 57.0827 60.3416 57.1368 60.1268 57.1479C60.3985 57.1618 60.6694 57.1071 60.9145 56.9889C60.8327 56.9894 60.7517 56.9729 60.6767 56.9404C60.6016 56.9079 60.5341 56.8602 60.4785 56.8002C60.4228 56.7403 60.3802 56.6694 60.3534 56.5921C60.3265 56.5148 60.316 56.4328 60.3225 56.3512C60.2721 56.3161 60.2251 56.2763 60.182 56.2324C60.1549 56.3203 60.1489 56.4133 60.1645 56.5039C60.1801 56.5946 60.2168 56.6802 60.2717 56.754C60.3267 56.8277 60.3982 56.8874 60.4805 56.9282C60.5629 56.969 60.6537 56.9898 60.7456 56.9889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.274 56.5454C61.4928 56.491 61.7053 56.4136 61.9078 56.3144C62.2277 56.188 62.5674 56.1195 62.9112 56.1119C62.5113 56.0989 62.1129 56.1678 61.7406 56.3144C61.538 56.4136 61.3256 56.491 61.1068 56.5454C61.0767 56.5454 61.0466 56.5454 61.0165 56.5554C61.1024 56.5632 61.189 56.5598 61.274 56.5454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.9378 58.1437C59.8057 58.1052 59.5933 57.906 59.4846 57.9027C60.0027 57.9107 60.5163 57.8056 60.9897 57.5947C60.8835 57.6386 60.7701 57.6624 60.6552 57.665C60.2286 57.8293 59.7744 57.91 59.3174 57.9027C59.4261 57.9027 59.6385 58.1035 59.7706 58.1437C59.8854 58.1716 60.0039 58.1812 60.1218 58.1721C60.0595 58.1705 59.9977 58.1609 59.9378 58.1437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.9362 61.9359C63.5266 61.9212 63.1259 61.8118 62.7656 61.6162C62.1151 61.2363 61.7439 60.505 61.5699 59.7753C61.5135 59.4129 61.4112 59.0592 61.2656 58.7226C61.1887 58.5672 61.0717 58.4352 60.9268 58.3402C60.7819 58.2451 60.6142 58.1906 60.4411 58.182C60.3577 58.1758 60.2738 58.1758 60.1903 58.182H60.2722C60.4453 58.1906 60.613 58.2451 60.7579 58.3402C60.9028 58.4352 61.0198 58.5672 61.0967 58.7226C61.2423 59.0592 61.3446 59.4129 61.401 59.7753C61.5683 60.5083 61.9462 61.2397 62.5967 61.6162C62.957 61.8118 63.3577 61.9212 63.7673 61.9359C63.8643 61.9359 63.9613 61.9359 64.06 61.9359H63.9362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.5499 57.6583C60.373 57.6455 60.202 57.5887 60.0525 57.4932C59.903 57.3976 59.7797 57.2663 59.6937 57.111C59.6274 57.0969 59.562 57.0784 59.498 57.0558C59.5916 57.2511 59.7423 57.4134 59.9302 57.521C60.1181 57.6286 60.3342 57.6765 60.5499 57.6583Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.6651 54.9956C54.6651 54.9956 54.1634 54.5738 54.6651 53.814C54.7317 53.7053 54.8231 53.6139 54.9318 53.5473C55.0405 53.4807 55.1635 53.4407 55.2905 53.4308C55.1357 53.4126 54.9788 53.4389 54.8384 53.5068C54.698 53.5747 54.5799 53.6813 54.4979 53.814C53.9962 54.5738 54.4979 54.9956 54.4979 54.9956C54.8234 55.0685 55.1559 55.1056 55.4895 55.106C55.2121 55.0923 54.9364 55.0553 54.6651 54.9956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.18285 55.0361L6.19632 54.9905C6.19632 54.9905 6.0246 54.9568 6.18285 55.0361Z",
    fill: "url(#paint14_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.9403 57.8407C21.9242 57.7874 21.9041 57.7353 21.8801 57.6851C21.8801 57.6683 21.8634 57.6549 21.855 57.6399C21.8399 57.61 21.8231 57.5809 21.8048 57.5528L21.7714 57.5093C21.7541 57.4866 21.7357 57.4649 21.7162 57.4441L21.6778 57.4056C21.6577 57.3872 21.6376 57.3704 21.6175 57.3554L21.5757 57.3252L21.5089 57.2851L21.467 57.2633L21.3918 57.2315L21.3533 57.2164C21.3177 57.2042 21.2814 57.1941 21.2446 57.1863C21.0013 57.1403 20.7509 57.1471 20.5105 57.2064C20.5105 57.2064 19.8098 58.2407 20.0791 58.6122L19.9904 58.5854C19.9904 58.5854 14.7846 64.3995 11.8481 65.4789C11.7734 65.4276 11.6959 65.3796 11.6157 65.335V64.2472C11.6181 64.2015 11.6181 64.1556 11.6157 64.1099C11.6106 64.0666 11.6034 64.0236 11.5939 63.9811L11.6157 63.9693L11.7026 63.9208L11.828 63.8438L11.9083 63.7919C11.9685 63.7507 12.0243 63.7072 12.0755 63.6614L12.1408 63.6045C12.1809 63.571 12.2193 63.5359 12.2561 63.4991L12.323 63.4338C12.3699 63.3858 12.4144 63.3367 12.4568 63.2865L12.5036 63.2296C12.5438 63.1794 12.5822 63.1281 12.619 63.0757L12.6658 63.0054C12.6993 62.954 12.7311 62.9016 12.7612 62.8481L12.7913 62.7962C12.8281 62.7276 12.8632 62.6556 12.8933 62.582L12.92 62.5167C12.9434 62.4575 12.9652 62.3979 12.9853 62.3376C12.9853 62.3158 13.0003 62.2958 13.0053 62.274C13.0287 62.1953 13.0505 62.1167 13.0672 62.0347C13.0672 62.018 13.0672 62.0029 13.0756 61.9862C13.0889 61.9181 13.0995 61.8489 13.1073 61.7786C13.1073 61.7552 13.1073 61.7318 13.1073 61.7083C13.1073 61.623 13.1207 61.541 13.1207 61.4489C13.1208 60.7978 12.8977 60.1663 12.4886 59.6599C12.711 59.3118 12.8565 59.1059 12.8565 59.1059C12.7227 59.0139 12.5906 58.9302 12.4602 58.8482L12.3331 58.7729C12.2461 58.721 12.1658 58.6691 12.0722 58.6223L11.9267 58.5453C11.8481 58.5034 11.7712 58.4633 11.6943 58.4264L11.5454 58.3578L11.323 58.2608L11.1775 58.2022C11.1039 58.1737 11.0304 58.147 10.9585 58.1219L10.8213 58.075C10.7461 58.0516 10.6708 58.0298 10.5972 58.0097L10.4752 57.9763C10.3915 57.9562 10.3079 57.9394 10.226 57.9227L10.1374 57.9043C10.0253 57.8842 9.91495 57.8691 9.80291 57.8591C9.11863 57.7857 8.42704 57.8918 7.79617 58.167C7.82962 57.3671 7.9634 56.7077 8.24434 56.2993L8.17578 56.2759L8.15237 56.2993C8.15237 56.2993 8.07043 56.3177 7.94166 56.3412C7.90103 56.4062 7.86471 56.4739 7.83296 56.5437C7.88917 56.2606 7.99748 55.9905 8.15237 55.747L8.0838 55.7236C8.18247 55.6215 8.54034 55.1814 8.06039 54.4601C7.50854 53.6333 6.49849 54.276 6.49849 54.276C6.41841 54.549 6.36575 54.8293 6.34129 55.1128C6.26437 55.081 6.20918 55.0575 6.17406 55.0391C5.69018 56.748 5.42661 58.5117 5.38976 60.2875C3.56865 62.8748 2.81613 66.6939 2.66897 67.5173L2.65726 67.5826C2.64723 67.6429 2.64221 67.6747 2.64221 67.6747L7.37643 67.7851C7.37643 67.8019 7.37643 67.8169 7.37643 67.8336V75.3363L3.92987 82.6315C3.92987 82.6315 5.24093 82.6733 7.21422 82.926L6.66906 86.8271L6.48678 87.9216H9.76779C10.1323 87.192 8.30956 86.8271 8.30956 86.8271H8.26943L8.98015 83.1871C9.29453 83.2395 9.61784 83.2953 9.95007 83.3544C10.4372 83.4487 10.9309 83.5047 11.4267 83.5218C11.8372 83.5362 12.2481 83.5182 12.6558 83.4682C12.8966 85.4414 12.5806 86.6196 12.5204 86.8154H12.502L12.3197 87.9099H15.6007C15.9184 87.274 14.5739 86.9142 14.2244 86.8338L14.2395 86.7267C14.4082 85.4958 14.4514 84.251 14.3682 83.0114C14.7916 82.8396 15.1863 82.6043 15.5388 82.3135L15.584 82.2733L15.5974 82.2599L13.1542 75.3982C13.6107 73.4569 12.022 71.4185 12.8699 70.3992C13.7177 69.38 13.2043 68.0797 13.104 67.8571C15.3983 66.8529 20.0356 64.3426 21.3366 59.9912C21.4322 59.6853 21.5098 59.3741 21.5691 59.0591C21.5691 59.0591 22.2246 58.793 21.9403 57.8407Z",
    fill: "url(#paint15_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.70252 56.3093C6.70252 56.3093 4.21585 64.1601 8.38651 68.5064L9.59055 67.5843C9.59055 67.5843 7.12561 59.0155 8.50524 57.0039C6.0704 56.1922 6.70252 56.3093 6.70252 56.3093Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42164 57.0022C8.42164 57.0022 8.92332 56.5805 8.42164 55.8206C7.91995 55.0608 6.98849 55.6533 6.98849 55.6533C6.98849 55.6533 6.65403 56.7495 6.98849 57.0022C7.32295 57.2549 8.42164 57.0022 8.42164 57.0022Z",
    fill: "#F6B9AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30619 65.9408C9.30619 66.5933 9.8344 67.1223 10.486 67.1223C11.1376 67.1223 11.6658 66.5933 11.6658 65.9408V64.8044C11.6658 64.1519 11.1376 63.6229 10.486 63.6229C9.8344 63.6229 9.30619 64.1519 9.30619 64.8044V65.9408Z",
    fill: "#F6B9AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.42158 68.0897C9.42158 68.0897 6.98674 59.6264 8.31286 57.5461C8.42992 57.5244 8.50517 57.5076 8.50517 57.5076L8.52691 57.4875L8.58878 57.5076C7.20915 59.5159 9.67409 68.088 9.67409 68.088L8.47005 69.0102L8.3647 68.8963L9.42158 68.0897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4434 64.8462C11.886 64.8462 13.0555 63.6758 13.0555 62.2321C13.0555 60.7883 11.886 59.6179 10.4434 59.6179C9.00078 59.6179 7.8313 60.7883 7.8313 62.2321C7.8313 63.6758 9.00078 64.8462 10.4434 64.8462Z",
    fill: "#F6B9AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.3716 65.9425V64.8044C11.3715 64.7211 11.3625 64.6381 11.3448 64.5567C11.8549 64.2945 12.2646 63.8716 12.5108 63.3533C12.7569 62.8349 12.8257 62.2499 12.7066 61.6885C12.5875 61.1271 12.2872 60.6206 11.8519 60.247C11.4166 59.8734 10.8705 59.6535 10.298 59.6213H10.4451C11.0311 59.6212 11.6 59.8181 12.0606 60.1806C12.5212 60.5431 12.8466 61.05 12.9846 61.6199C13.1226 62.1898 13.0651 62.7896 12.8214 63.3228C12.5776 63.8561 12.1618 64.2918 11.6408 64.5601C11.6585 64.6414 11.6675 64.7245 11.6676 64.8078V65.9458C11.6691 66.1138 11.6345 66.2802 11.5661 66.4337C11.4977 66.5871 11.3971 66.7241 11.2711 66.8352C11.1452 66.9463 10.9968 67.029 10.8361 67.0777C10.6754 67.1264 10.5062 67.1399 10.3398 67.1173C10.625 67.0803 10.887 66.9407 11.0769 66.7245C11.2668 66.5083 11.3715 66.2303 11.3716 65.9425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78943 75.261C7.78943 75.261 12.828 75.83 13.0136 75.261C13.6156 73.42 12.0103 71.4301 12.813 70.4578C13.6491 69.4536 13.0136 68.093 13.0136 68.093C13.0136 67.3997 12.7384 66.7348 12.2486 66.2445C11.7587 65.7543 11.0943 65.4789 10.4015 65.4789C9.70876 65.4789 9.04436 65.7543 8.5545 66.2445C8.06463 66.7348 7.78943 67.3997 7.78943 68.093V75.261Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.8196 70.4578C13.6558 69.4536 13.0203 68.093 13.0203 68.093C13.0203 67.3997 12.7451 66.7348 12.2552 66.2445C11.7654 65.7543 11.101 65.4789 10.4082 65.4789C10.3513 65.4789 10.2962 65.4789 10.241 65.4872C10.9031 65.5294 11.5243 65.8222 11.9784 66.3062C12.4325 66.7902 12.6855 67.4291 12.6858 68.093C12.6858 68.093 13.3213 69.4536 12.4852 70.4578C11.6758 71.4301 13.2879 73.4183 12.6858 75.261C12.629 75.4367 12.1089 75.5036 11.4182 75.5137C12.2694 75.522 12.9551 75.4651 13.0203 75.261C13.629 73.4167 12.0102 71.4301 12.8196 70.4578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9451 75.0936C13.7846 77.7027 14.599 81.6457 14.0722 85.438L14.0572 85.5518H12.4869C12.4869 85.5518 12.9735 84.1176 12.4869 81.5888C12.1886 80.0727 11.3404 78.7207 10.1056 77.7931L8.59048 85.5518H7.12891L8.59048 75.0936H11.9451Z",
    fill: "#F6B9AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8014 60.0531C20.8014 60.0531 21.4085 59.7987 21.1476 58.9234C20.8867 58.0482 19.8265 58.3427 19.8265 58.3427C19.8265 58.3427 19.1827 59.2916 19.4318 59.633C19.681 59.9744 20.8014 60.0531 20.8014 60.0531Z",
    fill: "#F6B9AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8632 68.5147C11.8632 68.5147 19.6911 65.9759 20.7998 60.0531L19.35 59.6079C19.35 59.6079 13.589 66.0445 11.1558 66.0897C8.72263 66.1349 11.8632 68.5147 11.8632 68.5147Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.5339 60.0598L20.7764 60.1335C19.6677 66.0563 11.8397 68.5951 11.8397 68.5951L11.7009 68.4863C12.6257 68.165 19.5004 65.5843 20.5339 60.0598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.76948 77.7931L8.25439 85.5518H8.58885L10.0605 78.0207C9.9674 77.9399 9.87028 77.864 9.76948 77.7931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.9452 75.0936H11.6107C13.4502 77.7027 14.2646 81.6457 13.7379 85.438L13.7228 85.5518H14.0573L14.0723 85.438C14.5991 81.6457 13.788 77.7027 11.9452 75.0936Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.6392 60.0012C20.6392 60.0012 21.2463 59.7468 20.9854 58.8715C20.9537 58.748 20.8933 58.6337 20.809 58.538C20.7247 58.4423 20.619 58.3679 20.5004 58.3209C20.6539 58.349 20.7961 58.4202 20.9104 58.5264C21.0248 58.6325 21.1065 58.7691 21.1459 58.9201C21.4068 59.7937 20.7998 60.0497 20.7998 60.0497C20.4674 60.0243 20.1388 59.9626 19.8198 59.8656C20.0887 59.9335 20.3628 59.9789 20.6392 60.0012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78951 74.9764L4.61218 81.6708C6.46517 81.7633 8.30929 81.987 10.1307 82.3402C13.6425 83.0096 15.3148 81.336 15.3148 81.336L13.0488 74.9764H7.78951Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63224 85.52C8.63224 85.52 10.3045 85.8547 9.97006 86.5242H6.95996L7.12719 85.52H8.63224Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9836 85.52C13.9836 85.52 15.6558 85.8547 15.3214 86.5242H12.3113L12.4785 85.52H13.9836Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.813 60.0816C12.813 60.0816 8.79953 65.7717 10.639 68.1148L3.44824 67.9474C3.44824 67.9474 5.45498 55.0608 12.813 60.0816Z",
    fill: "#FCCC63"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.813 60.0816C11.7762 59.3736 10.8464 59.0222 10.0119 58.9402C10.7135 59.1607 11.3764 59.4894 11.9769 59.9142C11.9769 59.9142 7.96339 65.6044 9.8029 67.9474L3.47333 67.8001C3.45661 67.8955 3.44824 67.9474 3.44824 67.9474L10.639 68.1148C8.79953 65.7718 12.813 60.0816 12.813 60.0816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.0571 74.9764H12.5554L14.8214 81.336C14.8214 81.336 13.7411 82.4155 11.4935 82.4925C14.0805 82.5762 15.323 81.336 15.323 81.336L13.0571 74.9764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.63231 85.52H8.29785C8.29785 85.52 9.97013 85.8547 9.63567 86.5242H9.97013C10.3046 85.8547 8.63231 85.52 8.63231 85.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.9836 85.52H13.6492C13.6492 85.52 15.3214 85.8547 14.987 86.5242H15.3214C15.6559 85.8547 13.9836 85.52 13.9836 85.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.766 28.0626H83.7177V30.4893H147.766V28.0626Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 27.2877H82.4434V110.297H149V27.2877Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.766 30.4894H83.7177V107.39H147.766V30.4894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2026 29.9036C85.5258 29.9036 85.7879 29.6413 85.7879 29.3178C85.7879 28.9943 85.5258 28.7321 85.2026 28.7321C84.8794 28.7321 84.6173 28.9943 84.6173 29.3178C84.6173 29.6413 84.8794 29.9036 85.2026 29.9036Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8114 29.9036C87.1346 29.9036 87.3967 29.6413 87.3967 29.3178C87.3967 28.9943 87.1346 28.7321 86.8114 28.7321C86.4881 28.7321 86.2261 28.9943 86.2261 29.3178C86.2261 29.6413 86.4881 29.9036 86.8114 29.9036Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4217 29.9036C88.745 29.9036 89.007 29.6413 89.007 29.3178C89.007 28.9943 88.745 28.7321 88.4217 28.7321C88.0985 28.7321 87.8364 28.9943 87.8364 29.3178C87.8364 29.6413 88.0985 29.9036 88.4217 29.9036Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.92 33.9202H87.7311V35.4264H143.92V33.9202Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.645 40.4471H87.3966V66.2203H111.645V40.4471Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.143 41.2839H87.8983V65.3835H111.143V41.2839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.92 53.3337H119.672V79.1069H143.92V53.3337Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.418 54.1705H120.173V78.2701H143.418V54.1705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.923 85.1317H87.8983V102.872H144.923V85.1317Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M143.92 86.3032H89.0688V102.202H143.92V86.3032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90.4067 87.8094H143.92V86.3032H89.0688V102.202H90.4067V87.8094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.292 46.564C105.706 44.719 103.522 43.4907 101.122 43.0938C98.723 42.697 96.2606 43.1569 94.1657 44.3931C92.0708 45.6294 90.4768 47.5633 89.6624 49.8566C88.848 52.15 88.8651 54.6569 89.7107 56.9389C90.5563 59.2209 92.1765 61.1329 94.2881 62.3404C96.3997 63.5479 98.8682 63.9741 101.262 63.5445C103.656 63.1149 105.823 61.8568 107.383 59.9903C108.944 58.1238 109.8 55.7675 109.8 53.3337C109.803 50.8489 108.913 48.4461 107.292 46.564ZM103.111 59.5293C101.746 60.3386 100.152 60.6735 98.5775 60.4819C97.0028 60.2903 95.5355 59.5829 94.4042 58.4699C93.273 57.3569 92.5412 55.9008 92.3229 54.3283C92.1047 52.7558 92.4121 51.1552 93.1974 49.7757C93.9827 48.3963 95.2018 47.3154 96.6648 46.7015C98.1277 46.0876 99.7525 45.9751 101.286 46.3815C102.82 46.7879 104.176 47.6904 105.143 48.9484C106.111 50.2064 106.636 51.7494 106.636 53.337C106.64 54.5868 106.317 55.8158 105.7 56.9021C105.082 57.9883 104.191 58.894 103.116 59.5293H103.111Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.629 48.8586L106.912 46.8921C105.987 45.8143 104.84 44.9494 103.55 44.3569C102.26 43.7644 100.857 43.4583 99.437 43.4596V46.472C100.423 46.4718 101.398 46.6849 102.294 47.0968C103.19 47.5087 103.987 48.1097 104.629 48.8586Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.437 60.1938C98.4607 60.1943 97.4958 59.9848 96.6075 59.5796L95.365 62.3259C96.812 62.9827 98.3961 63.28 99.9826 63.1926C101.569 63.1052 103.111 62.6356 104.477 61.8238L102.939 59.2314C101.88 59.8634 100.67 60.196 99.437 60.1938Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.304 53.332C109.307 50.9668 108.457 48.6799 106.912 46.8904L104.63 48.8568C105.285 49.6152 105.766 50.5083 106.039 51.4731C106.312 52.4379 106.369 53.4509 106.208 54.4405C106.047 55.4301 105.671 56.3723 105.106 57.2004C104.541 58.0285 103.801 58.7224 102.939 59.233L104.477 61.8254C105.949 60.9503 107.168 59.7071 108.014 58.218C108.86 56.7289 109.304 55.0451 109.304 53.332Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5806 53.332C92.5806 51.5122 93.303 49.7669 94.5888 48.4801C95.8746 47.1933 97.6185 46.4703 99.4369 46.4703V43.4579C97.1821 43.458 94.9952 44.231 93.2405 45.6483C91.4859 47.0656 90.2692 49.0417 89.7932 51.2474C89.3172 53.4532 89.6104 55.7556 90.6242 57.7713C91.638 59.787 93.3111 61.3944 95.3649 62.3258L96.6074 59.5795C95.4074 59.0354 94.3894 58.1568 93.6753 57.0488C92.9612 55.9409 92.5811 54.6505 92.5806 53.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.077 57.6851H123.351V60.6975H141.077V57.6851Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.91 57.8523H123.518V60.53H140.91V57.8523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.227 62.3711H123.518V65.0488H136.227V62.3711Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.214 66.8898H123.518V69.5675H132.214V66.8898Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.237 71.4083H123.518V74.0861H139.237V71.4083Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.815 70.2369H87.8983V71.7432H112.815V70.2369Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.945 72.7472H87.8983V74.2534H101.945V72.7472Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.303 72.7472H104.454V74.2534H109.303V72.7472Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.303 78.27H104.454V79.7762H109.303V78.27Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.945 77.7679H87.8983V79.2742H101.945V77.7679Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.815 75.2576H87.8983V76.7638H112.815V75.2576Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.254 40.6145H119.337V42.1207H144.254V40.6145Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.384 43.1249H119.337V44.6311H133.384V43.1249Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.742 43.1249H135.893V44.6311H140.742V43.1249Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.742 48.6477H135.893V50.1539H140.742V48.6477Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.384 48.1456H119.337V49.6519H133.384V48.1456Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.254 45.6353H119.337V47.1415H144.254V45.6353Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.197 117.097C128.213 117.097 129.036 116.273 129.036 115.256C129.036 114.24 128.213 113.415 127.197 113.415C126.181 113.415 125.357 114.24 125.357 115.256C125.357 116.273 126.181 117.097 127.197 117.097Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.197 116.595C127.936 116.595 128.535 115.996 128.535 115.256C128.535 114.517 127.936 113.917 127.197 113.917C126.458 113.917 125.859 114.517 125.859 115.256C125.859 115.996 126.458 116.595 127.197 116.595Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.374 94.8385H72.8478V115.089H130.374V94.8385Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.371 95.6753H74.5201V111.574H129.371V95.6753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3595 108.562H127.197",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3866 98.8551H76.8613V108.06H84.3866V98.8551Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9684 99.2734H77.2793V107.809H83.9684V99.2734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.859 105.382H119.17V108.06H125.859V105.382Z",
    fill: "#69F0AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.317 101.868H106.628V107.892H113.317V101.868Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6009 102.872H91.9117V107.892H98.6009V102.872Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.371 111.574H74.5201V113.917H129.371V111.574Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8612 117.097C77.8772 117.097 78.7007 116.273 78.7007 115.256C78.7007 114.24 77.8772 113.415 76.8612 113.415C75.8453 113.415 75.0217 114.24 75.0217 115.256C75.0217 116.273 75.8453 117.097 76.8612 117.097Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8613 116.595C77.6001 116.595 78.1991 115.996 78.1991 115.256C78.1991 114.517 77.6001 113.917 76.8613 113.917C76.1224 113.917 75.5234 114.517 75.5234 115.256C75.5234 115.996 76.1224 116.595 76.8613 116.595Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5201 96.3447H73.1823V113.917H74.5201V96.3447Z",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.5201 96.3447H73.1823V113.917H74.5201V96.3447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6087 98.2125C74.6087 98.194 74.6087 98.1773 74.6087 98.1589C74.6087 98.1405 74.6087 98.1037 74.6087 98.0769C74.6087 98.0501 74.6087 98.0417 74.5987 98.025C74.5886 98.0083 74.587 97.9748 74.5786 97.9514C74.5702 97.9279 74.5686 97.9196 74.5619 97.9028C74.5552 97.8861 74.5418 97.856 74.5318 97.8325L74.5117 97.7907C74.4983 97.7673 74.4833 97.7439 74.4682 97.7221L74.4465 97.6903C74.4246 97.6601 74.4011 97.6311 74.3763 97.6033C74.2429 97.461 74.0848 97.3442 73.9097 97.2585C74.0467 97.1112 74.149 96.9351 74.209 96.743C74.2264 96.6917 74.2398 96.6391 74.2492 96.5857C74.2492 96.569 74.2492 96.5523 74.2492 96.5372C74.2537 96.505 74.2565 96.4726 74.2575 96.4401C74.2575 96.4217 74.2575 96.405 74.2575 96.3866C74.2575 96.3682 74.2575 96.3313 74.2575 96.3046C74.2575 96.2778 74.2575 96.2694 74.2475 96.2527C74.2375 96.2359 74.2358 96.2025 74.2274 96.179C74.2191 96.1556 74.2174 96.1473 74.2107 96.1305C74.204 96.1138 74.1906 96.0837 74.1806 96.0602L74.1605 96.0184C74.1471 95.995 74.1321 95.9715 74.1171 95.9498L74.0953 95.918C74.0734 95.8878 74.0499 95.8588 74.0251 95.8309C73.8583 95.656 73.6558 95.519 73.4314 95.4293C73.4314 95.4293 72.3695 95.8226 72.2993 96.2544C71.52 96.4217 66.9781 97.3673 63.8593 97.292L63.8359 97.2301C63.8361 96.7251 63.6987 96.2297 63.4385 95.7971C63.1783 95.3645 62.8052 95.0111 62.3593 94.7749V93.7239C62.3617 93.6793 62.3617 93.6346 62.3593 93.59C62.3548 93.5473 62.3481 93.5048 62.3392 93.4628L62.3593 93.4511L62.4445 93.4043L62.5683 93.3289L62.6469 93.2771C62.7049 93.2369 62.7606 93.1945 62.8141 93.1499L62.8777 93.0946C62.9161 93.0612 62.9529 93.0277 62.9897 92.9925L63.0549 92.929C63.1006 92.8821 63.1441 92.8341 63.1854 92.785L63.2305 92.7281C63.2695 92.679 63.3069 92.6288 63.3426 92.5775L63.3877 92.5089C63.42 92.4587 63.4513 92.4074 63.4814 92.3549L63.5098 92.3047C63.5466 92.2378 63.58 92.1675 63.6101 92.0972L63.6352 92.0336C63.6586 91.9767 63.6798 91.9209 63.6988 91.8662L63.7188 91.8043C63.7422 91.7273 63.7623 91.6503 63.779 91.5717C63.779 91.5566 63.779 91.5399 63.7874 91.5248C63.7997 91.4579 63.8097 91.3904 63.8175 91.3223C63.8175 91.2989 63.8175 91.2771 63.8175 91.2537C63.8175 91.17 63.8309 91.0863 63.8309 91.001C63.8308 90.5254 63.7081 90.0579 63.4747 89.6437C63.6536 89.6002 63.7623 89.5651 63.7489 89.5483C63.6804 89.4563 63.6118 89.3692 63.5399 89.2856L63.4713 89.2069C63.4212 89.15 63.3727 89.0965 63.3225 89.0396L63.2422 88.9575C63.1921 88.9073 63.1419 88.8605 63.0917 88.8153L63.0131 88.745C62.9496 88.6914 62.886 88.6396 62.8225 88.5894L62.7807 88.5559C62.7037 88.499 62.6268 88.4454 62.5482 88.3885L62.4613 88.335C62.4111 88.3032 62.3593 88.2731 62.3074 88.2463L62.2037 88.1927L62.0599 88.1241L61.9546 88.0772C61.9044 88.0555 61.8526 88.0371 61.8007 88.0187L61.7054 87.9835C61.6285 87.9584 61.5515 87.935 61.4746 87.9149L61.3559 87.8881L61.2271 87.8613L61.0984 87.8413L60.9796 87.8279L60.8475 87.8162H60.7338H60.6017C60.5292 87.8162 60.4568 87.8195 60.3843 87.8262C58.6736 87.9668 57.1752 89.4613 57.1752 91.8428V93.8076H59.8508V94.7013C59.3699 94.9233 58.9626 95.2785 58.6769 95.7248C58.3913 96.1711 58.2392 96.69 58.2388 97.22V104.836L55.9678 115.278H55.9377L55.4912 117.271L58.6953 117.79L58.8341 117.812C59.1686 117.668 58.6083 116.993 58.3558 116.473C58.33 116.419 58.3077 116.363 58.2889 116.306C58.2537 116.201 58.2323 116.091 58.2254 115.981L60.687 107.899H60.6753L60.7338 107.71C60.7338 107.71 63.8677 109.049 64.6737 111.742C65.3276 113.917 64.9212 115.333 64.7439 115.792H64.7322V115.819C64.6971 115.906 64.672 115.954 64.672 115.954H64.7322V117.432H68.1203C68.4346 117.273 67.7674 116.809 67.4346 116.428C67.3257 116.307 67.2497 116.16 67.2139 116.001H67.2707L67.2975 115.88C67.7234 113.901 67.6257 111.844 67.0139 109.913C66.4021 107.983 65.2974 106.246 63.8091 104.873C63.8153 104.864 63.8204 104.855 63.8242 104.845C64.1439 103.866 64.3411 102.85 64.4111 101.822C67.0015 102.07 70.4481 101.893 73.0251 99.8944C73.271 99.7084 73.5061 99.5083 73.7291 99.2953C73.9515 99.2785 74.3411 99.1547 74.5569 98.5254C74.5742 98.4741 74.5876 98.4215 74.597 98.3681C74.597 98.3514 74.597 98.3346 74.597 98.3196C74.603 98.2841 74.6069 98.2484 74.6087 98.2125Z",
    fill: "url(#paint26_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0364 101.161C61.0364 101.161 68.8794 103.657 73.224 99.4877L72.3026 98.281C72.3026 98.281 63.8743 100.16 61.8659 98.7831C59.8575 97.4057 61.0364 101.161 61.0364 101.161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.0033 99.3304L73.1572 99.5313C68.8092 103.702 60.9696 101.205 60.9696 101.205C60.9696 101.205 60.9495 101.141 60.9194 101.037C61.8542 101.317 68.9497 103.227 73.0033 99.3304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0569 99.4861C73.0569 99.4861 73.699 99.6317 73.995 98.7698C74.291 97.9079 73.2592 97.528 73.2592 97.528C73.2592 97.528 72.1839 97.9246 72.1873 98.3463C72.1906 98.7681 73.0569 99.4861 73.0569 99.4861Z",
    fill: "#985454"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.9548 99.3505C72.9548 99.3505 73.5969 99.4961 73.8929 98.6342C73.9387 98.5153 73.9558 98.3872 73.9427 98.2603C73.9297 98.1335 73.8868 98.0116 73.8177 97.9045C73.9263 98.0166 74.0007 98.1575 74.0321 98.3105C74.0635 98.4634 74.0506 98.6222 73.9949 98.7681C73.6989 99.6317 73.0568 99.4844 73.0568 99.4844C72.8015 99.2698 72.5705 99.0279 72.3678 98.7631C72.5468 98.9749 72.7431 99.1714 72.9548 99.3505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7506 115.02H67.0734C67.0648 115.13 67.0799 115.24 67.1177 115.343C67.1555 115.446 67.2152 115.54 67.2925 115.618C67.6052 115.979 68.234 116.416 67.938 116.565H64.7506V115.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.1235 115.618C67.0462 115.54 66.9866 115.446 66.9488 115.343C66.911 115.24 66.8958 115.13 66.9044 115.02H67.0717C67.0631 115.13 67.0782 115.24 67.116 115.343C67.1538 115.446 67.2134 115.54 67.2907 115.618C67.6035 115.979 68.2322 116.416 67.9362 116.565H67.769C68.065 116.416 67.4362 115.981 67.1235 115.618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4779 114.542L58.6518 114.898C58.5917 115.157 58.6267 115.429 58.7505 115.665C58.988 116.167 59.5214 116.793 59.2003 116.928L56.0531 116.426L56.4779 114.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.5849 115.663C58.4612 115.428 58.4262 115.155 58.4863 114.896L56.4712 114.562V114.535L58.6452 114.891C58.585 115.15 58.6201 115.423 58.7438 115.658C58.9813 116.16 59.5147 116.786 59.1937 116.921L59.0615 116.9C59.309 116.736 58.8124 116.135 58.5849 115.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1435 95.3958C60.1435 96.0484 60.6717 96.5774 61.3233 96.5774C61.9748 96.5774 62.5031 96.0484 62.5031 95.3958V94.2595C62.5031 93.6069 61.9748 93.0779 61.3233 93.0779C60.6717 93.0779 60.1435 93.6069 60.1435 94.2595V95.3958Z",
    fill: "#985454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2807 94.3013C62.7233 94.3013 63.8928 93.1309 63.8928 91.6871C63.8928 90.2434 62.7233 89.073 61.2807 89.073C59.8381 89.073 58.6686 90.2434 58.6686 91.6871C58.6686 93.1309 59.8381 94.3013 61.2807 94.3013Z",
    fill: "#985454"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.2087 95.3975V94.2595C62.2086 94.1762 62.1997 94.0932 62.182 94.0118C62.6921 93.7496 63.1018 93.3267 63.3479 92.8084C63.594 92.29 63.6629 91.705 63.5438 91.1436C63.4247 90.5822 63.1243 90.0757 62.689 89.7021C62.2537 89.3285 61.7077 89.1086 61.1351 89.0764H61.2823C61.8682 89.0762 62.4372 89.2732 62.8978 89.6357C63.3584 89.9982 63.6838 90.5051 63.8218 91.075C63.9597 91.6449 63.9022 92.2447 63.6585 92.7779C63.4148 93.3112 62.999 93.7469 62.478 94.0152C62.4957 94.0965 62.5046 94.1796 62.5047 94.2628V95.4009C62.5063 95.5689 62.4716 95.7353 62.4032 95.8888C62.3348 96.0422 62.2343 96.1791 62.1083 96.2903C61.9824 96.4014 61.834 96.4841 61.6733 96.5328C61.5126 96.5815 61.3433 96.595 61.1769 96.5724C61.4622 96.5354 61.7242 96.3958 61.9141 96.1796C62.1039 95.9634 62.2087 95.6854 62.2087 95.3975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6267 104.716C58.6267 104.716 63.6653 105.285 63.8509 104.716C65.157 100.709 63.8509 97.5481 63.8509 97.5481C63.8509 96.8548 63.5757 96.1899 63.0858 95.6996C62.596 95.2094 61.9316 94.934 61.2388 94.934C60.546 94.934 59.8816 95.2094 59.3918 95.6996C58.9019 96.1899 58.6267 96.8548 58.6267 97.5481V104.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6267 104.716L56.3507 115.174H58.6267L60.9863 107.415C60.9863 107.415 63.9362 108.681 64.6937 111.211C65.4513 113.742 64.6937 115.174 64.6937 115.174H67.1419L67.167 115.06C67.5692 113.197 67.475 111.26 66.8939 109.445C66.3128 107.629 65.2651 105.999 63.8559 104.716",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.5566 104.716C64.8627 100.709 63.5566 97.5479 63.5566 97.5479C63.5567 96.8838 63.3042 96.2445 62.8505 95.76C62.3967 95.2754 61.7756 94.9818 61.1134 94.9388C61.1686 94.9388 61.2254 94.9388 61.2806 94.9388C61.9734 94.9388 62.6378 95.2143 63.1277 95.7045C63.6175 96.1948 63.8927 96.8597 63.8927 97.553C63.8927 97.553 65.1988 100.716 63.8927 104.721C63.8258 104.925 63.1369 104.982 62.2807 104.974C62.9763 104.959 63.4997 104.892 63.5566 104.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.9428 107.6L58.6267 115.216H58.2922L60.6518 107.457C60.6518 107.457 60.7605 107.504 60.9428 107.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.5148 104.758H63.8492C65.2584 106.041 66.3061 107.671 66.8872 109.487C67.4683 111.302 67.5625 113.239 67.1603 115.102L67.1352 115.216H66.8008L66.8259 115.102C67.2281 113.239 67.1339 111.302 66.5528 109.487C65.9716 107.671 64.924 106.041 63.5148 104.758Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.702 99.4877C60.702 99.4877 68.545 101.983 72.8895 97.8141L71.9681 96.6074C71.9681 96.6074 63.5398 98.4869 61.5314 97.1095C59.523 95.7321 60.702 99.4877 60.702 99.4877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.6688 97.6569L72.8227 97.8577C68.4748 102.028 60.6351 99.5313 60.6351 99.5313C60.6351 99.5313 60.6151 99.4677 60.585 99.3639C61.5198 99.6434 68.6152 101.553 72.6688 97.6569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7224 97.8125C72.7224 97.8125 73.3645 97.9581 73.6605 97.0962C73.9565 96.2343 72.9247 95.8544 72.9247 95.8544C72.9247 95.8544 71.8494 96.251 71.8528 96.6728C71.8561 97.0945 72.7224 97.8125 72.7224 97.8125Z",
    fill: "#985454"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.6204 97.6769C72.6204 97.6769 73.2626 97.8225 73.5586 96.9606C73.6044 96.8417 73.6215 96.7136 73.6084 96.5868C73.5953 96.46 73.5525 96.338 73.4833 96.231C73.592 96.3431 73.6664 96.4839 73.6978 96.6369C73.7292 96.7899 73.7163 96.9486 73.6606 97.0945C73.3646 97.9581 72.7224 97.8108 72.7224 97.8108C72.4672 97.5963 72.2361 97.3544 72.0334 97.0895C72.2125 97.3013 72.4088 97.4978 72.6204 97.6769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4763 90.8203L61.309 94.3348H57.63V92.4688C57.63 88.7216 61.5883 87.2991 63.8174 90.3098C63.8726 90.3918 61.4763 90.8203 61.4763 90.8203Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.6501 88.7015C61.5883 88.7784 62.5532 89.2906 63.3158 90.3198C63.371 90.3934 60.9746 90.8219 60.9746 90.8219L60.8073 94.3364H61.309L61.4763 90.8219C61.4763 90.8219 63.8726 90.3934 63.8175 90.3198C62.9194 89.1048 61.7388 88.6195 60.6501 88.7015Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 35.7232,
    y1: 81.3361,
    x2: 35.7232,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1937.1,
    y1: 747.251,
    x2: 1937.1,
    y2: 727.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1937.1,
    y1: 859.72,
    x2: 1937.1,
    y2: 839.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 2807.02,
    y1: 859.72,
    x2: 2807.02,
    y2: 839.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 1068.05,
    y1: 164.848,
    x2: 1068.05,
    y2: 144.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1068.05,
    y1: 194.972,
    x2: 1068.05,
    y2: 174.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1068.05,
    y1: 225.097,
    x2: 1068.05,
    y2: 204.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1068.05,
    y1: 255.221,
    x2: 1068.05,
    y2: 234.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 13146.2,
    y1: 8364.89,
    x2: 13146.2,
    y2: 4599.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 24663.1,
    y1: 8907.87,
    x2: 24312.4,
    y2: 5057.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 1144.33,
    y1: 689.882,
    x2: 1141.36,
    y2: 657.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 1248.19,
    y1: 669.701,
    x2: 1245.22,
    y2: 637.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 102.516,
    y1: 72.7259,
    x2: 102.516,
    y2: 72.7137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 6660.18,
    y1: 16861,
    x2: 6660.18,
    y2: 11864.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 21.5107,
    y1: 77.2961,
    x2: 21.5107,
    y2: 77.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 4423.36,
    y1: 21056.2,
    x2: 4423.36,
    y2: 14195.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 46139.7,
    y1: 54734.8,
    x2: 46139.7,
    y2: 13562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 14517.9,
    y1: 10238.4,
    x2: 14517.9,
    y2: 6269.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 19230,
    y1: 12235.8,
    x2: 19230,
    y2: 8266.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 39783.9,
    y1: 10989.5,
    x2: 39783.9,
    y2: 9109.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 15623,
    y1: 9903.48,
    x2: 15623,
    y2: 7330.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 14138,
    y1: 1150.24,
    x2: 14138,
    y2: 1096.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 2923.7,
    y1: 2689.56,
    x2: 2923.7,
    y2: 2608.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 35027,
    y1: 14020.6,
    x2: 35027,
    y2: 11570.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 3704.93,
    y1: 6042.14,
    x2: 3704.93,
    y2: 5535.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 1765.96,
    y1: 2689.56,
    x2: 1765.96,
    y2: 2608.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 9353.28,
    y1: 21348.4,
    x2: 11538.4,
    y2: 21348.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 119,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeCta);
export default __webpack_public_path__ + "static/media/upgrade-cta.cc8555ccd88a841b184815c12f0f6b5d.svg";
export { ForwardRef as ReactComponent };